import { render } from "./TeamLeadRewardSettingsForm.vue?vue&type=template&id=0c7bf36f&ts=true"
import script from "./TeamLeadRewardSettingsForm.vue?vue&type=script&lang=ts"
export * from "./TeamLeadRewardSettingsForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__